const formattedCurrentMonthSummaryData = (data) =>
  data.map((d, index) => {
    return {
      id: index + 1,
      ...d,
    };
  });

const roundData = (data) =>
  Object.fromEntries(
    Object.entries(data).map(([key, value]) => [
      key,
      typeof value === "number" ? Math.round(value) : value,
    ])
  );

export { formattedCurrentMonthSummaryData, roundData };
